// extracted by mini-css-extract-plugin
export default {"inputText":"ContactDetails_inputText__DVpXV","error":"ContactDetails_error__PtgcL"};